var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sky",staticClass:"sky"},[_c('canvas',{ref:"canvas"}),_c('div',{staticClass:"bg-img"}),_c('div',{staticClass:"filter"})])
}
var staticRenderFns = []

export { render, staticRenderFns }